import logo from "./logo.png";

export default { logo };
